export default __webpack_public_path__ + "static/media/btn_step_1_active.cb6908fc.svg";